import { render, staticRenderFns } from "./SelectImage.vue?vue&type=template&id=4a915770&scoped=true"
import script from "./SelectImage.vue?vue&type=script&lang=js"
export * from "./SelectImage.vue?vue&type=script&lang=js"
import style0 from "./SelectImage.vue?vue&type=style&index=0&id=4a915770&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a915770",
  null
  
)

export default component.exports